import { render } from "./PartnersCarousel.vue?vue&type=template&id=fb6692c2&scoped=true"
import script from "./PartnersCarousel.vue?vue&type=script&lang=js"
export * from "./PartnersCarousel.vue?vue&type=script&lang=js"

import "./PartnersCarousel.vue?vue&type=style&index=0&id=fb6692c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb6692c2"]])

export default __exports__